import request from '@/middleware/request'

const getBotCaller = data => {
  return request({
    url: '/debugs/bot_caller',
    method: 'post',
    data
  })
}

const getSession = data => {
  return request({
    url: '/debugs/session',
    method: 'post',
    data
  })
}

const getSessionLog = data => {
  return request({
    url: '/debugs/session_log',
    method: 'post',
    data
  })
}

export default {
  getBotCaller,
  getSession,
  getSessionLog
}
